import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

/**
 * Фон карточки — цвет статуса команды (тот же тон, что у `TeamStatusBadge`) на 10%
 * прозрачности, а не обычный белый: карточку сразу видно среди других по статусу.
 */
export const HeadBlock = styled.div`
  width: 100%;
  gap: 0;
  border-radius: 8px;
  position: relative;

  padding: 20px;
  display: flex;
  flex-direction: column;

  background: ${theme.colors.SurfaceWhite};
  box-shadow: 0 0 20px 0 #0000001a;

  z-index: 10;

  &[data-tone='pending'] {
    background: ${theme.colors.CasePending}1a;
  }

  &[data-tone='accepted'] {
    background: ${theme.colors.CaseSuccess}1a;
  }

  &[data-tone='declined'] {
    background: ${theme.colors.CaseError}1a;
  }
`;

export const BodyBlock = styled.div`
  top: -8px;
  position: relative;
  padding-block: 28px 8px;
  border-radius: 0 0 8px 8px;

  background: ${theme.colors.SurfaceWhite};

  z-index: 5;
`;

export const TitleField = styled.div<{ width: number }>`
  gap: 8px;
  display: flex;
  flex-direction: column;

  width: ${({ width }) => width}px;
`;

/**
 * Статус команды рядом с её именем — те же тона `Case*`, что у чипов фильтра заявок
 * (`applications-v2/application-status-chips.tsx`), но статичная плашка без кнопки:
 * это не фильтр, а просто индикатор текущего состояния команды.
 */
export const TeamStatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 24px;
  padding: 0 10px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  cursor: help;

  &[data-tone='pending'] {
    background: ${theme.colors.CasePendingSurfaceActive};
    color: ${theme.colors.CasePendingText};
  }

  &[data-tone='accepted'] {
    background: ${theme.colors.CaseSuccessSurfaceActive};
    color: ${theme.colors.CaseSuccessText};
  }

  &[data-tone='declined'] {
    background: ${theme.colors.CaseErrorSurfaceActive};
    color: ${theme.colors.CaseErrorText};
  }
`;
